import React from 'react'
import styled from 'styled-components'

const SectionMobileV2 = ({ style, className, id, title, children }) => (
  <Wrapper style={style} className={className} id={id}>
    {title && <Title>{title}</Title>}
    <Container>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.props['data-slot']) return
        return child
      })}
    </Container>
  </Wrapper>
)

export default SectionMobileV2

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 20px;
  flex-direction: column;
  gap: 14px;
  border-bottom: 1px solid #ececec;
  background: #ffffff;

  @media screen and (min-width: 750px) {
    padding-inline: 100px;
  }
`

const Container = styled.div`
  display: flex;
  flex: 1 0 0;
`

const Title = styled.h2`
  color: #1d1e22;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: 0;
`



// WEBPACK FOOTER //
// ./src/components/SectionMobileV2/index.js